import { render } from "./ReadonlyShallowReadonly.vue?vue&type=template&id=532e98b2"
import script from "./ReadonlyShallowReadonly.vue?vue&type=script&lang=ts"
export * from "./ReadonlyShallowReadonly.vue?vue&type=script&lang=ts"
script.render = render

export default script